var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Box, Link, Typography } from "@mui/material";
import { FormItemTypes } from "../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { downloadAttachmentFfrAPI } from "../../../../../fieldFailureReports/services/apiCalls";
import { renderIcon } from "../../../../../fieldFailureReports/components/CommonFunctions";
var handleAttachmentDownload = function (value) { return __awaiter(void 0, void 0, void 0, function () {
    var request, res, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!value) return [3 /*break*/, 2];
                request = value;
                return [4 /*yield*/, downloadAttachmentFfrAPI({
                        request: request
                    })];
            case 1:
                res = _a.sent();
                url = URL.createObjectURL(res === null || res === void 0 ? void 0 : res.data);
                window.open(url, '_blank');
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
export var commonCardData = [{
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                sx: {
                    pt: 0
                },
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "",
                                label: "",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "CauseOFFaillureObservedDuringPrepare",
                                        label: "Why? Cause of Failure Observed During Repair:",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "TemporaryActionTakenInField",
                                        label: "Temporary Action Taken in Field:",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "HowYouIdentifiedDefectivePart",
                                        label: "How? How You Identified Defective Part?:",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }]
    }];
export var commonAttachmentData = [{
        type: FormItemTypes.Typography,
        name: "",
        fontSize: "md",
        fontWeight: "strong",
        children: "Attachments",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.ContainerItem,
        name: '',
        columnSize: 12,
        pt: 2,
        elements: [{
                type: FormItemTypes.List,
                columnSize: 12,
                name: 'Attachments',
                disableCheckboxSelection: true,
                value: null,
                columns: [{
                        field: 'ContentType',
                        maxWidth: 50,
                        renderCell: function (_ref) {
                            var row = _ref.row;
                            return renderIcon(row === null || row === void 0 ? void 0 : row.FileName);
                        }
                    }, {
                        field: "FileName",
                        flex: 1,
                        align: "left",
                        renderCell: function (_ref2) {
                            var value = _ref2.value, row = _ref2.row;
                            return /*#__PURE__*/ React.createElement(Box, {
                                sx: {
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.5
                                }
                            }, /*#__PURE__*/ React.createElement(Link, {
                                underline: "hover",
                                variant: "button",
                                color: "text.primary",
                                onClick: function () { return handleAttachmentDownload(row); }
                            }, value), /*#__PURE__*/ React.createElement(Typography, {
                                variant: "h6",
                                color: "text.secondary"
                            }, "Remarks:"));
                        }
                    }, {
                        field: "Size",
                        width: 465,
                        align: "left",
                        renderCell: function (_ref3) {
                            var value = _ref3.value, row = _ref3.row;
                            return /*#__PURE__*/ React.createElement(Box, {
                                sx: {
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.5
                                }
                            }, /*#__PURE__*/ React.createElement(Typography, {
                                variant: "h6",
                                sx: {
                                    alignSelf: "flex-end"
                                },
                                color: "text.secondary"
                            }, "".concat(Math.round(value / 1000), " KB")), /*#__PURE__*/ React.createElement(Typography, {
                                variant: "h6",
                                color: "text",
                                sx: {
                                    fontSize: "12px"
                                }
                            }, row === null || row === void 0 ? void 0 : row.Remark));
                        }
                    }]
            }]
    }];
export var problemDescriptionOrChangeView = __spreadArray(__spreadArray(__spreadArray([], commonCardData, true), [{
        type: FormItemTypes.Typography,
        name: "",
        fontSize: "md",
        fontWeight: "strong",
        children: "Customer Complaint",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                sx: {
                    pt: 0
                },
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "Product details",
                                label: "JC invoice return details",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "ProblemDescription",
                                        label: "what (Problem Description):",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "RoadCondition",
                                        label: "Where (Road Condition):",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }, {
                        type: FormItemTypes.Divider,
                        name: "Divider",
                        orientation: "vertical",
                        columnSize: 0,
                        containerProps: {
                            height: "100%"
                        }
                    }, {
                        type: FormItemTypes.Box,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "productCodede",
                                label: "Return invoice summary",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "TemperatureConditionName",
                                        label: "When",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "VehicleSpeed",
                                        label: "Vehicle speed (Km/Hr):",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }]
    }], false), commonAttachmentData, true);
export var problemDescriptionOrChangeMobileView = __spreadArray(__spreadArray(__spreadArray([], commonCardData, true), [{
        type: FormItemTypes.Typography,
        name: "customercomplaint",
        fontSize: "md",
        fontWeight: "strong",
        children: "Customer Complaint",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                sx: {
                    pt: 0
                },
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "Product details",
                                label: "JC invoice return details",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "ProblemDescription",
                                        label: "what (Problem Description):",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "RoadCondition",
                                        label: "Where (Road Condition):",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "TemperatureConditionName",
                                        label: "When",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "VehicleSpeed",
                                        label: "Vehicle speed (Km/Hr):",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }]
    }], false), commonAttachmentData, true);
